module.exports = "<div class=\"has-text-centered\">\n  <i class=\"fa fa-spinner fa-spin fa-4x\" ></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/bypass/bypass.component.html
// module id = ../../../../../src/app/modules/bypass/bypass.component.html
// module chunks = main